const state = {
  isRepAuthenticated: false,
  landingInfo: null,
  landingUrl: null,
  repInfo: null,
  groupInfo: null,
  isEmployeeEnrollment:false,
  isContinueEnrollmentLandingPage: false,
  isOver65: false,
  isGroupViewPlans: false,
  innerLandingUrl: '',
  isHomePageRedirect: false,
  themeColorList: []
}

const mutations = {
  setRepAuthenticatedState: (state, payload) => {
    state.isRepAuthenticated = payload
  },
  setLandingInfo: (state, payload) => {
    state.landingInfo = payload
  },
  setLandingUrl: (state, payload) => {
    state.landingUrl = payload
  },
  setRepInfo: (state, payload) => {
    state.repInfo = payload
  },
  setGroupInfo: (state, payload) => {
    state.groupInfo = payload
  },
  setEmployeeEnrollmentState: (state, payload) => {
    state.isEmployeeEnrollment = payload
  },
  setContinueEnrollmentFlag: (state, payload) => {
    state.isContinueEnrollmentLandingPage = payload
  },
  setAgeStatus: (state, payload) => {
    state.isOver65 = payload
  },
  setGroupViewPlans: (state, payload) => {
    state.isGroupViewPlans = payload
  },
  setInnerLandingInfo: (state, payload) => {
    state.innerLandingUrl = payload
  },
  setHomePageRedirect: (state, payload) => {
    state.isHomePageRedirect = payload
  },
  setThemeColor: (state, payload) => {
    state.themeColorList = payload
  }
}

const actions = {
  isEmployeeEnrollment: ({commit}, payload) => {
    commit('setEmployeeEnrollmentState', payload)
  },
  isRepAuthenticated: ({commit}, payload) => {
    commit('setRepAuthenticatedState', payload)
  },
  landingInfo: ({commit}, payload) => {
    commit('setLandingInfo', payload)
  },
  landingUrl: ({commit}, payload) => {
    commit('setLandingUrl', payload)
  },
  repInfo: ({commit}, payload) => {
    commit('setRepInfo', payload)
  },
  groupInfo: ({commit}, payload) => {
    commit('setGroupInfo', payload)
  },
  continueEnrollmentInfo: ({commit}, payload) => {
    commit('setContinueEnrollmentFlag', payload)
  },
  isOver65: ({commit}, payload) => {
    commit('setAgeStatus', payload)
  },
  isGroupViewPlans: ({commit}, payload) => {
    commit('setGroupViewPlans', payload)
  },
  innerLandingUrl: ({commit}, payload) => {
    commit('setInnerLandingInfo', payload)
  },
  isHomePageRedirect: ({commit}, payload) => {
    commit('setHomePageRedirect', payload)
  },
  themeColorList: ({commit}, payload) => {
    commit('setThemeColor', payload)
  }
}
export default {
  state,
  mutations,
  actions
}
